<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <a-button type="primary" :disabled="!selectedRowKeys.length" @click="handleShowExportModal">
            {{$t('identificationRecord.exportBtn')}}
          </a-button>
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearchList">
          <a-form-item>
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              style="width: 130px"
              :placeholder="$t('identificationRecord.personTypeTxt')"
              :options="personTypeOptions"
              v-decorator="['personType',  {initialValue: ''}]"
            />
          </a-form-item>

          <a-form-item>
            <a-range-picker
              dropdownClassName="form-date-picker"
              :getCalendarContainer="trigger => trigger.parentNode"
              style="width: 250px"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="[$t('identificationRecord.startTimeTxt'), $t('identificationRecord.endTimeTxt')]"
              :ranges="searchDateRangesBtn"
              v-decorator="['dateRange', {initialValue: [moment(), moment()]}]"
              :disabledDate="current => current > moment()"
            />
          </a-form-item>

          <a-form-item>
            <a-tree-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              style="width: 140px"
              :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
              :placeholder="$t('identificationRecord.deviceOrgTxt')"
              :treeData="orgTreeDownSelectionData"
              :treeDefaultExpandedKeys="[orgTreeDownSelectionData[0].value]"
              v-decorator="['deptId', {initialValue: orgTreeDownSelectionData[0].value}]"
            />
          </a-form-item>

          <a-form-item>
            <a-input
              style="width: 190px"
              type="text"
              v-decorator="['name']"
              :placeholder="$t('identificationRecord.personalOrDeviceNameTxt')" >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>

          <a-form-item style="margin-right:0">
            <a-button type="primary" html-type="submit" :loading="loading">{{$t('identificationRecord.searchBtn')}}</a-button>
          </a-form-item>
        </a-form>
      </div>

      <TableTips
        :total="pagination.total"
        :selected="selectedRowKeys.length"
        @clearAllSelected="() => {selectedRowKeys = []; selectedRowItems = []}"
      />
      <a-table
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: rowKeys => selectedRowKeys = rowKeys }"
        :columns="tableColumns"
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"

        size="middle"
      >
        <!-- :scroll="tableData.length?{ x: 1500 }:{}" -->
        <template v-slot:temperature="text, record">
          <span v-if="record.temperature.normal === 1" style="color:#F5222d">{{record.temperature.value}}</span>
          <span v-else-if="record.temperature.normal === 0" style="color:#52C41A">{{record.temperature.value}}</span>
          <span v-else>{{record.temperature.value}}</span>
        </template>
        <div slot="img" slot-scope="text, record">
          <img v-if="record.img" @click="handleShowImg" :src="record.img" :alt="$t('identificationRecord.listSitePhotos')" style="width: 100%;cursor: pointer;">
          <span v-else>--</span>
        </div>
      </a-table>
    </div>

    <!-- 导出模态框 -->
    <a-modal
      :title="$t('identificationRecord.exportModalTitle')"
      :visible="downloadModalVisible"
      :okText="$t('identificationRecord.confirmBtn')"
      :cancelText="$t('identificationRecord.cancelBtn')"
      @ok="handleDownloadOk"
      :confirmLoading="confirmDownloadLoading"
      @cancel="()=>{downloadModalVisible=false}"
      :afterClose="handleDownloadModalHide"
    >
      <!-- <p style="font-size: 14px;color:#faad14;margin-bottom: 0">
        <a-icon type="exclamation-circle" theme="twoTone" two-tone-color="#faad14" style="margin-right: 5px"/>
        {{downloadModalTips}}
      </p> -->
      <a-form-model
        ref="downloadForm"
        :model="downloadForm"
        :rules="downloadFormRules"
      >
        <a-form-model-item prop="columns">
          <template v-slot:label>
            <span>
              {{$t('identificationRecord.exportField')}}
            </span>
            <span style="font-size: 14px;color:#faad14;">
              （{{downloadModalTips}}）
            </span>
          </template>
          <a-checkbox-group v-model="downloadForm.columns" style="margin-top:10px;padding-left:20px">
            <a-checkbox :value="Number(1)" name="type"> {{$t('identificationRecord.f_Organization')}} </a-checkbox>
            <a-checkbox :value="Number(2)" name="type"> {{$t('identificationRecord.f_DeviceSN')}} </a-checkbox>
            <a-checkbox :value="Number(3)" name="type"> {{$t('identificationRecord.f_DeviceName')}} </a-checkbox>
            <a-checkbox :value="Number(4)" name="type"> {{$t('identificationRecord.f_Surname')}} </a-checkbox>
            <a-checkbox :value="Number(5)" name="type"> {{$t('identificationRecord.f_IDNumber')}} </a-checkbox>
            <a-checkbox :value="Number(6)" name="type"> {{$t('identificationRecord.f_MaskCheck')}} </a-checkbox>
            <a-checkbox :value="Number(7)" name="type"> {{$t('identificationRecord.f_Temp')}} </a-checkbox>
            <a-checkbox :value="Number(8)" name="type"> {{$t('identificationRecord.f_RM')}} </a-checkbox>
            <a-checkbox :value="Number(9)" name="type"> {{$t('identificationRecord.f_RecognitionTime')}} </a-checkbox>
            <a-checkbox :value="Number(10)" name="type"> {{$t('identificationRecord.f_SitePhotos')}} </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 查看照片 -->
    <a-modal
      class="show-img-modal"
      :title="$t('identificationRecord.photoModalTitle')"
      :footer="null"
      :visible="showImgModalVisible"
      @cancel="()=>{showImgModalVisible=false}"
      :afterClose="()=>{showImgUrl=''}"
    >
      <a-card style="width: 100%;">
        <img
          slot="cover"
          alt="example"
          :src="showImgUrl"
        />
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import { downLoadFileViaAjaxPost, deleteSelectedRow } from '../../utils/utils'
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { getRecognRecords } from '@/api/recognMana';
import TableTips from '@/components/TableTips';

export default {
  name: 'identificationRecordIndex',
  components: { TableTips },
  data() {
    return {
      showDownloadModalVisible: false,

      listSearchForm: this.$form.createForm(this),
      personTypeOptions: [],

      selectedRowKeys: [],

      searchDeptFullName: '',
      searchName: '',
      searchFromDate: moment().format('YYYY-MM-DD'),
      searchToDate: moment().format('YYYY-MM-DD'),
      searchDateRangesBtn: this.getSearchDateRangesBtn(),

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      // 导出
      downloadModalVisible: false,
      confirmDownloadLoading: false,
      downloadModalTips: '',
      downloadForm: {
        columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      },
      downloadFormRules: {
        columns: [
          { validator: this.handleValidDownladColumns }
        ]
      },

      showImgModalVisible: false,
      showImgUrl: ''
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData,
      orgTreeSourceData: state => state.orgStore.orgTreeSourceData
    }),
    ...mapGetters(['orgTreeDownSelectionData', 'orgAutoCompletedSourceData'])
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
      this.searchDateRangesBtn = this.getSearchDateRangesBtn()
      this.personTypeOptions = [].concat([{ title: this.$t('identificationRecord.option_allType'), value: '', key: 'all' }], this.enumsData.authTargetType);
    }
  },
  created() {
    this.personTypeOptions = [].concat([{ title: this.$t('identificationRecord.option_allType'), value: '', key: 'all' }], this.enumsData.authTargetType);
    this.getListData();
  },
  methods: {
    moment,

    getTableColumns() {
      return [
        {
          title: this.$t('identificationRecord.listOrg'),
          dataIndex: 'deptFullName',
          width: '12%'
        },
        {
          title: this.$t('identificationRecord.listDeviceSN'),
          dataIndex: 'deviceSn',
          width: '12%'
        },
        {
          title: this.$t('identificationRecord.listDeviceName'),
          dataIndex: 'deviceName',
          width: '12%'
        },
        {
          title: this.$t('identificationRecord.listPersonalType'),
          dataIndex: 'authTargetTypeName',
          width: '8%'
        },
        {
          title: this.$t('identificationRecord.listPersonalName'),
          dataIndex: 'name',
          width: '8%'
        },
        {
          title: this.$t('identificationRecord.listIDNumber'),
          dataIndex: 'idNumber',
          width: '9%'
        },
        {
          title: this.$t('identificationRecord.listMaskCheck'),
          dataIndex: 'maskCheck',
          width: '6%'
        },
        {
          title: this.$t('identificationRecord.listTemperature'),
          dataIndex: 'temperature',
          width: '6%',
          scopedSlots: { customRender: 'temperature' }
        },
        {
          title: this.$t('identificationRecord.listRM'),
          dataIndex: 'recognizeType',
          width: '7%'
        },
        {
          title: this.$t('identificationRecord.listRecognitionTime'),
          dataIndex: 'recognizeAt'
          // width: '10%'
        },
        {
          title: this.$t('identificationRecord.listSitePhotos'),
          dataIndex: 'img',
          align: 'center',
          width: 100,
          // fixed: 'right',
          scopedSlots: { customRender: 'img' }
        }
      ]
    },
    // 获取时间段选择插件快捷按钮内容
    getSearchDateRangesBtn() {
      const btns = {}
      btns[this.$t('identificationRecord.aWeekBeforeBtn')] = [this.moment().subtract(6, 'days'), this.moment()]
      btns[this.$t('identificationRecord.oneMonthBeforeBtn')] = [this.moment().subtract(1, 'months'), this.moment()]
      btns[this.$t('identificationRecord.threeMonthsBeforeBtn')] = [this.moment().subtract(3, 'months'), this.moment()]
      return btns
    },

    // 搜素列表
    handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.searchDeptFullName = this.orgAutoCompletedSourceData.find(org => org.id === values.deptId).name;
          this.searchName = values.name;
          this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD');
          this.searchToDate = values.dateRange[1].format('YYYY-MM-DD');
          this.searchPersonType = values.personType

          this.pagination.current = 1;
          deleteSelectedRow(undefined, this.selectedRowKeys)
          this.getListData();
        }
      });
    },
    // 获取列表数据
    async getListData() {
      try {
        this.loading = true;
        const res = await getRecognRecords({
          deptFullName: this.searchDeptFullName || this.orgTreeDownSelectionData[0].fullName,
          fromDate: this.searchFromDate,
          toDate: this.searchToDate,
          name: this.searchName,
          authTargetTypeCodes: [this.searchPersonType],
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.loading = false;

        this.tableData = this.createRecordTableData(res.data.collection);
        this.pagination.total = res.data.size;
      } catch (error) {
        this.loading = false;
      }
    },
    createRecordTableData(data) {
      return data.map(item => {
        return {
          key: item.id,
          id: item.id,
          deptFullName: item.deviceDeptFullName,
          deviceSn: item.deviceSn,
          deviceName: item.deviceName,
          authTargetTypeName: item.authTargetTypeName,
          name: item.targetName,
          idNumber: item.targetIdNumber,
          maskCheck: item.maskCheckResultName || '--',
          temperature: {
            value: item.temperature && item.temperature.toFixed(1),
            normal: item.temperatureCheckResultCode
          },
          recognizeType: item.recognizeTypeName,
          recognizeAt: item.recognizeAt,
          img: item.scenePhotoUrl
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.getListData();
    },

    // 打开导出模态框
    handleShowExportModal() {
      this.downloadModalVisible = true
      this.downloadModalTips = new Function('count', this.$t('identificationRecord.exportTips'))(this.selectedRowKeys.length)
    },
    // 提交导出
    handleDownloadOk() {
      this.$refs.downloadForm.validate(valid => {
        if (valid) {
          this.confirmDownloadLoading = true;

          downLoadFileViaAjaxPost(
            '/face/web/record/export_record',
            {
              columns: this.downloadForm.columns,
              ids: this.selectedRowKeys
            },
            `${this.$t('identificationRecord.exportFilePrefix')}(${this.searchFromDate} ~ ${this.searchToDate})`,
            'xlsx',
            () => {
              this.downloadModalVisible = false;
              this.$notification.success({
                message: this.$t('identificationRecord.exportSuccess')
              });
            }
          )
        }
      });
    },
    // 验证导出字段选择
    handleValidDownladColumns(rule, value, callback) {
      if (!value.length) {
        callback(this.$t('identificationRecord.exportWarning'));
        return;
      }
      callback();
    },
    // 关闭导出模态框
    handleDownloadModalHide() {
      this.confirmDownloadLoading = false;
      this.downloadModalTips = ''
      this.downloadForm = {
        columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      }
    },

    // 查看列表图片
    handleShowImg(e) {
      this.showImgUrl = e.target.src;
      this.showImgModalVisible = true;
    }
  }

}
</script>

<style>
  .show-img-modal .ant-modal{
    top: 30px
  }

  .ant-form-item label{
    width: 30%;
    margin-left: 0 !important;
    margin-bottom: 10px;
  }
</style>
<style scoped>
</style>
